import { render } from "./MobileFooter.vue?vue&type=template&id=7becc378&scoped=true&ts=true"
import script from "./MobileFooter.vue?vue&type=script&lang=ts"
export * from "./MobileFooter.vue?vue&type=script&lang=ts"

import "./MobileFooter.vue?vue&type=style&index=0&id=7becc378&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7becc378"]])

export default __exports__